import React, { memo } from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { SPACING } from '@/constants/shared/theme';
import { Text } from '@/components/common/text';
import { AnchoredDropdownItem } from '@/components/common/admin/desktop/dropdown/AnchoredDropdownItem';
import { AdaptiveMenu } from './AdaptiveMenu';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

interface ThreadActionsMenuProps {
  visible: boolean;
  onClose: () => void;
  isOwnThread: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onReport: () => void;
  onSave: () => void;
  isSaved: boolean;
}

export const ThreadActionsMenu: React.FC<ThreadActionsMenuProps> = memo(({
  visible,
  onClose,
  isOwnThread,
  onEdit,
  onDelete,
  onReport,
  onSave,
  isSaved,
}) => {
  const { semantic } = useThemeColors();
  return (
    <AdaptiveMenu visible={visible} onClose={onClose}>
      <View style={styles.content}>
        {/* Save / Bookmark */}
        <AnchoredDropdownItem style={styles.actionItem} onPress={onSave} accessibilityRole="button" accessibilityLabel={isSaved ? 'Unsave thread' : 'Save thread'}>
          <Text style={[styles.actionText, { color: semantic.text.primary }]}>{isSaved ? 'Unsave thread' : 'Save thread'}</Text>
        </AnchoredDropdownItem>

        {isOwnThread ? (
          <>
            <AnchoredDropdownItem style={styles.actionItem} onPress={onEdit} accessibilityRole="button" accessibilityLabel="Edit thread">
              <Text style={[styles.actionText, { color: semantic.text.primary }]}>Edit thread</Text>
            </AnchoredDropdownItem>

            <AnchoredDropdownItem style={styles.actionItem} onPress={onDelete} accessibilityRole="button" accessibilityLabel="Delete thread">
              <Text style={[styles.actionTextDanger, { color: semantic.interactive.danger }]}>Delete thread</Text>
            </AnchoredDropdownItem>
          </>
        ) : (
          <AnchoredDropdownItem style={styles.actionItem} onPress={onReport} accessibilityRole="button" accessibilityLabel="Report thread">
            <Text style={[styles.actionTextDanger, { color: semantic.interactive.danger }]}>Report thread</Text>
          </AnchoredDropdownItem>
        )}
      </View>
    </AdaptiveMenu>
  );
});

const styles = StyleSheet.create({
  content: {
    gap: 4,
  },
  actionItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    paddingVertical: 14,
    // Web: 8pt so the rounded hover tint keeps air around the label; the
    // phone bottom sheet keeps its 4.
    paddingHorizontal: Platform.OS === 'web' ? SPACING.sm : SPACING.xs,
    borderRadius: 8,
  },
  actionText: {
    fontSize: 16,
    fontWeight: '400',
  },
  actionTextDanger: {
    fontSize: 16,
    fontWeight: '400',
  },
});
